"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _q = _interopRequireDefault(require("q"));

var _createPublicI18nProvider = _interopRequireDefault(require("I18n/init/providers/createPublicI18nProvider"));

var _registerAllData = _interopRequireDefault(require("I18n/init/register/lazy/registerAllData"));

var _en = _interopRequireDefault(require("i2l?query=sporks!../lang/en.lyaml"));

var _en2 = _interopRequireDefault(require("i2l?query=sporks!timezone-utils/lang/en.lyaml"));

function changeLocale(locale, language) {
  var I18nProvider = (0, _createPublicI18nProvider.default)({
    manuallySetLocale: true,
    excludeFallback: true
  });

  var translationsAvailablePromise = _q.default.Promise.all([I18nProvider.register(_en.default), I18nProvider.register(_en2.default), (0, _registerAllData.default)(I18nProvider)]);

  var langEnabled = language !== 'en';
  I18nProvider.setLocale({
    locale: locale,
    langEnabled: langEnabled
  });
  return translationsAvailablePromise;
}

var _default = function _default(WrappingComponent) {
  function I18nLoader(props) {
    return _react.default.createElement(WrappingComponent, (0, _extends2.default)({}, props, {
      changeLocale: changeLocale
    }));
  }

  I18nLoader.displayName = WrappingComponent.displayName ? "connectI18nLoader(" + WrappingComponent.displayName + ")" : 'connectI18nLoader(Component)';
  return I18nLoader;
};

exports.default = _default;
module.exports = exports.default;